import { cva } from 'class-variance-authority'

export const imageSizes = {
  sm: 'w-[80px] h-[80px]',
  md: 'w-[120px] h-[120px]',
  lg: 'w-[180px] h-[180px]',
} as const

export const containerStyles = cva('flex w-full items-center justify-center', {
  variants: {
    size: {
      sm: 'pt-4 pb-4 rounded-2xl',
      md: 'pt-6 pb-6 rounded-3xl',
      lg: 'pt-6 pb-6 rounded-3xl',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
